import { Log } from 'ng2-logger';
import Types, { GlobalState } from '../../models/action/core.d';
import { actions } from '../constants/link';
import { ISetAddLink, ISetDeleteLink } from '../../models/action/link';

const _logger = Log.create('Link Reducer');

const setLinkData = (newState: any, linkPageAction: any  ) => {
        if (linkPageAction) {
            newState.linkData = {
                activityId: linkPageAction.activityId,
                abbreviation: linkPageAction.abbreviation,
                name: linkPageAction.name,
                description: linkPageAction.description,
                isCommon: linkPageAction.isCommon ? 1 : 0,
                dateCriteria: linkPageAction.dateCriteria ?? 0,
                datePrerequisiteActivityHours: linkPageAction.datePrerequisiteActivityHours ?? '',
                datePrerequisiteActivityId: linkPageAction.datePrerequisiteActivityId ? [linkPageAction.datePrerequisiteActivityId] : '',
                prerequisiteActivityId: linkPageAction.prerequisiteActivityId ?? '',
                completionType: linkPageAction.completionType ?? 1,
                alwaysOnTop: linkPageAction.alwaysOnTop,
                dateRange: '',
                fileInputKey: '',
                photoUploadKey: '',
                activityConditionalBeginDate: linkPageAction.beginDate,
                activityConditionalEndDate: linkPageAction.endDate,
                termWeekIds: linkPageAction.termWeekIds,
                selectedActivityOwnersTagIds: linkPageAction.selectedActivityOwnersTagIds,
                selectedActivityUnitsTagIds: linkPageAction.selectedActivityUnitsTagIds,
                selectedClass: linkPageAction.selectedClass,
                allUnits: linkPageAction.allUnits,
                courseId: linkPageAction.courseId,
                file: linkPageAction.file && linkPageAction.file.length > 0 ? linkPageAction.file : null,
                deletedFilesId: [],
                cardImgName: linkPageAction.cardImgName,
                customProperty3: linkPageAction.customProperty3 ?? '0',
                customProperty4: linkPageAction.customProperty4 ?? '',
                url: linkPageAction.fileEmbed,
                learningOutcomeId: linkPageAction.learningOutcomeId,
            };
        }
}

const linkReducer = (state = GlobalState().link, action: Types.IAction) => {
    if (!state) {
        return state;
    }
    const newState: any = { ...state };
    if (action.type === actions.ADD_LINK_SET_ACTIVITY) {
        const linkPageActionPayload = (action as unknown) as ISetAddLink;
        const linkPageAction = linkPageActionPayload?.linkData ? linkPageActionPayload.linkData[0] : null;
        setLinkData(newState, linkPageAction);
    } else if (action.type === actions.DELETE_LINK_SET_ACTIVITY) {
        const linkPageAction = (action as ISetDeleteLink);
        newState.deleteLinkStatus = linkPageAction.deleteLinkStatus;
    } else if (action.type === actions.SET_LINK_DATA_DEFAULT) {
        newState.linkData = {
            activityId: '',
            name: '',
            description: '',
            isCommon: 0,
            dateCriteria: 0,
            datePrerequisiteActivityHours: '',
            datePrerequisiteActivityId: '',
            prerequisiteActivityId: '',
            completionType: 1,
            alwaysOnTop: 0,
            dateRange: '',
            fileInputKey: '',
            photoUploadKey: '',
            activityConditionalBeginDate: '',
            activityConditionalEndDate: '',
            termWeekIds: [],
            selectedActivityOwnersTagIds: [],
            selectedActivityUnitsTagIds: [],
            selectedClass: [],
            allUnits: false,
            file: null,
            deletedFilesId: [],
            cardImgName: '',
            linkGenerator: 0,
            url: '',
            learningOutcomeId: null,
        };
    }
    return Object.assign({}, state, newState);
};

export default linkReducer;